/**
 * Public browser config. ONLY VITE_-prefixed, publishable values reach the bundle
 * (never the service role key — that lives in worker/). See ../../.env.example.
 */
const supabaseUrl = import.meta.env.VITE_SUPABASE_URL ?? '';
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY ?? '';
// Base URL of the ingestion server (worker/). e.g. https://ingest.example.com
const ingestBaseUrl = (import.meta.env.VITE_INGEST_URL ?? 'http://localhost:8787').replace(/\/$/, '');

export const env = { supabaseUrl, supabaseAnonKey, ingestBaseUrl } as const;

/** Names of any missing required public vars, for a friendly config screen. */
export const missingEnv: string[] = [
  ['VITE_SUPABASE_URL', supabaseUrl],
  ['VITE_SUPABASE_ANON_KEY', supabaseAnonKey],
  ['VITE_INGEST_URL', import.meta.env.VITE_INGEST_URL ?? ''],
]
  .filter(([, v]) => !v)
  .map(([k]) => k as string);
